import { StandardEvents } from '@shopify/events';

/**
 * The native Horizon facets system re-renders the product grid on every filter
 * change but never scrolls the results into view. This listens for the theme's
 * own collection:update / search:update events (dispatched by assets/facets.js
 * on every filter interaction), waits for the section re-render promise those
 * events carry to resolve, then scrolls the results list into view.
 *
 * Always scrolls once triggered — no "is it already visible" skip logic, since
 * that kind of heuristic is exactly the sort of thing that silently no-ops on
 * a layout it wasn't tested against.
 */
(() => {
  if (window.__rdFilterScrollApplied) return;
  window.__rdFilterScrollApplied = true;

  const SCROLL_OFFSET = 16; // breathing room below any sticky header

  const scrollToResults = () => {
    const target = document.getElementById('rd-scroll-to-products') || document.querySelector('results-list');
    if (!target) return;

    const header = document.querySelector('sticky-header, .header-wrapper[data-sticky]');
    const headerHeight = header ? header.getBoundingClientRect().height : 0;

    const rect = target.getBoundingClientRect();
    const top = window.scrollY + rect.top - headerHeight - SCROLL_OFFSET;
    window.scrollTo({ top, behavior: 'smooth' });
  };

  const handleFilterUpdate = (event) => {
    const promise = event && event.promise ? event.promise : Promise.resolve();
    promise
      .then(() => {
        // Let the section-render DOM swap settle before measuring positions.
        requestAnimationFrame(() => requestAnimationFrame(scrollToResults));
      })
      .catch(() => {
        // Even if the render promise rejects, still attempt the scroll —
        // the DOM may well have updated anyway.
        requestAnimationFrame(() => requestAnimationFrame(scrollToResults));
      });

    // Safety net: if the promise never resolves for some reason, scroll
    // anyway after a fixed delay so the feature never silently does nothing.
    window.setTimeout(scrollToResults, 900);
  };

  document.addEventListener(StandardEvents.collectionUpdate, handleFilterUpdate);
  document.addEventListener(StandardEvents.searchUpdate, handleFilterUpdate);
})();
